<div class="mt-4">
  <h1 class="title-container" [style]="config().title.styles">
    {{ config().title.label }}
  </h1>
  <div class="question-wrapper">
    @for (item of config().questions; track $index) {
      <p
        class="item"
        [innerHTML]="
          item.content
            | replaceVars
              : (dataService.currentCampaign().startDate
                  | date: 'EEEE dd MMMM yyyy') || ''
            | replaceVars
              : (dataService.currentCampaign().endDate
                  | date: 'EEEE dd MMMM yyyy') || ''
            | safe
        "
      ></p>
    }
  </div>
</div>
